(() => {
  'use strict';
  const isEditable = (node) => {
    const element = node && node.nodeType === 1 ? node : node && node.parentElement;
    return Boolean(element && element.closest('input, textarea, select, [contenteditable]:not([contenteditable="false"])'));
  };
  const protect = (event) => {
    if (isEditable(event.target) || isEditable(document.activeElement)) return;
    event.preventDefault();
  };
  document.addEventListener('copy', protect, true);
  document.addEventListener('cut', protect, true);
  document.addEventListener('selectstart', protect, true);
})();
